import { render, staticRenderFns } from "./NewLinkedBankAccountForm.vue?vue&type=template&id=3c55bc22&scoped=true"
import script from "./NewLinkedBankAccountForm.vue?vue&type=script&lang=ts"
export * from "./NewLinkedBankAccountForm.vue?vue&type=script&lang=ts"
import style0 from "./NewLinkedBankAccountForm.vue?vue&type=style&index=0&id=3c55bc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55bc22",
  null
  
)

export default component.exports